import { placeTypeValues } from "../data/destinations";
import type { PlaceForecast } from "./weather";

const KEY = "travel:favorites:v1";

export function readFavorites(): PlaceForecast[] {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) ?? "[]") as PlaceForecast[];
    return Array.isArray(value) ? value.map((place) => ({ ...place, category: placeTypeValues.has(place.category ?? "") ? place.category : undefined })) : [];
  } catch { return []; }
}

export function writeFavorites(items: PlaceForecast[]): void {
  localStorage.setItem(KEY, JSON.stringify(items.slice(0, 300)));
}
